//@flow
import React from 'react';

import {makeStyles, TableCell} from '@material-ui/core';
import CustomTextField from '../../../../../elements/CustomTextField/CustomTextField';

const useStyles = makeStyles(theme => ({
  textField: {
    width: '240px',
  },
  imageInputAdornment: {
    minWidth: '2.25rem',
    minHeight: '2.25rem',
    width: '2.25rem',
    height: '2.25rem',
    borderRadius: '.5rem',
    overflow: 'hidden',

    '& img': {
      width: '100%',
      height: '100%',
      objectFit: 'cover',
    },
  },
}));

export default function SizeGuideCell() {
  const classes = useStyles();
  return (
    <TableCell align="right">
      <CustomTextField
        name="size-guide"
        className={classes.textField}
        defaultValue=""
        type="text"
        InputProps={{
          startAdornment: (
            <picture className={classes.imageInputAdornment}>
              <img
                src="https://images.unsplash.com/photo-1678737171211-bf2c3def509f?ixlib=rb-4.0.3&ixid=MnwxMjA3fDB8MHxlZGl0b3JpYWwtZmVlZHwzfHx8ZW58MHx8fHw%3D&auto=format&fit=crop&w=500&q=60"
                alt="product"
              />
            </picture>
          ),
        }}
      />
    </TableCell>
  );
}
